const translations = {
    clientNameFieldLabel: 'Client Name'
};

export default translations;
